import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Logger } from '@core/services/logger.service';
import { StyleService } from '@core/services/style.service';
import { Style } from 'src/app/core/models/style.model';

@Component({
	selector: 'cass-order-select-style',
	templateUrl: './select-style.component.html',
	styleUrls: ['./select-style.component.css']
})
export class SelectStyleComponent {

	private readonly COMPONENT_NAME = "SelectStyleComponent";

	@Input()
	styles?: Style[];

	@Input()
	selectedStyle?: Style;

	@Output()
	styleChanged = new EventEmitter<Style>();

	constructor(
		private logger: Logger,
		private styleService: StyleService) { }

	selectStyle(style: Style): void {
		this.logger.debug(this.COMPONENT_NAME, `Selecting style id="${style?.id}" label="${style?.label}"`);
		this.selectedStyle = style;
		this.styleChanged.emit(style);
	}
}
